import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Items from "./Items";
import { ItemType } from "../../Services/ItemsService";
import ItemCategory from "../ItemInventory/Category/ItemCategory";
import UnitsItems from "../ItemInventory/UnitsItems";
import ItemLocations from "../ItemInventory/ItemLocations";
import { useClient } from "../../Context/ClientContext";
import ResourceNotFound from "../../Common/ResourceNotFound";
import { findUserOnlyOnePremission } from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";

const ItemNestedRoute = () => {
  const { companySettings, currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    switch (true) {
      case location.pathname.endsWith("/itemlocations") &&
        !companySettings?.setting?.item?.maintainItemLocation:
      case location.pathname.endsWith("/itemCategory") &&
        !companySettings?.setting?.item?.maintainCategory:
        navigate(-1);
        break;
      default:
        break;
    }
  }, [location.pathname, companySettings, navigate]);

  return (
    <Routes>
      <Route
        path="/items"
        element={
          findUserOnlyOnePremission(
            "Master.Item.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <Items itemPage={ItemType.All} />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/itemCategory"
        element={
          companySettings?.setting?.item?.maintainCategory &&
          findUserOnlyOnePremission(
            "Master.Item.Category.View",
            clientSpecificRole(),
            currentClient?.id!
          ) && <ItemCategory />
        }
      />
      {/* <Route path="/itemgroups" element={<ItemGroups />} /> */}

      <Route
        path="/itemlocations"
        element={
          companySettings?.setting?.item?.maintainItemLocation &&
          findUserOnlyOnePremission(
            "Master.Item.Locations.View",
            clientSpecificRole(),
            currentClient?.id!
          ) && <ItemLocations />
        }
      />
      <Route
        path="/units"
        element={
          findUserOnlyOnePremission(
            "Master.Item.Unit.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <UnitsItems />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
    </Routes>
  );
};

export default ItemNestedRoute;
